import RequestPageTwo from "./RequestPageTwo";

const GuestSpeakerReg = () => {
    return (
        <RequestPageTwo title="Guest Speaker Registrations"
            fetchUrl="/get-guest-speaker-registrations"
            editEndpoint="update-guest-speaker-registrations"
            deleteEndpoint="guest-speaker-registrations"
            statusEndpoint="update-guest-speaker-registrations" />
    );
}

export default GuestSpeakerReg;
